/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar23 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar23", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M13.753,21.543 H8.396v-1.196l2.227-2.095c1.035-0.957,1.299-1.313,1.299-1.729c0-0.518-0.381-0.864-0.962-0.864c-0.605,0-1.025,0.41-1.025,0.991 v0.034H8.294v-0.029c0-1.401,1.094-2.349,2.729-2.349c1.577,0,2.632,0.845,2.632,2.09c0,0.781-0.459,1.475-1.709,2.588l-1.162,1.069 v0.093h2.969V21.543z M18.762,21.734c-1.646,0-2.754-0.898-2.817-2.28h1.709c0.024,0.537,0.459,0.869,1.138,0.869 c0.635,0,1.074-0.361,1.074-0.889c0-0.542-0.415-0.874-1.099-0.874h-0.864v-1.235h0.864c0.601,0,0.996-0.337,0.996-0.85 s-0.386-0.83-1.011-0.83c-0.615,0-1.03,0.366-1.05,0.918h-1.626c0.024-1.377,1.079-2.256,2.715-2.256 c1.562,0,2.637,0.786,2.637,1.924c0,0.811-0.542,1.45-1.333,1.597v0.093c0.972,0.103,1.592,0.742,1.592,1.65 C21.687,20.845,20.485,21.734,18.762,21.734z M24,10H6V6h18V10z" />
      </svg>
    );
  }
}

IconCalendar23.defaultProps = {
  className: null
};

IconCalendar23.propTypes = {
  className: PropTypes.string
};

export default IconCalendar23;
